var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentMethods && _vm.paymentMethods.pix)?_c('div',{staticClass:"pt-2"},[_c('p',[_vm._v("\n        Após realizar o pagamento do Pix, ele será confirmado pelo banco e seu pedido entrará em\n        produção.\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }